function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("radialGradient", {
  cx: -578.95,
  cy: -837.6,
  gradientTransform: "translate(499.5 629.5) scale(0.75)",
  gradientUnits: "userSpaceOnUse",
  id: "radial-gradient",
  r: 197.06
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f9ed32"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#ee2a7b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#d22a8a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#8b2ab2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#1b2af0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#002aff"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "3-instagram",
  id: "_3-instagram"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  height: 64,
  rx: 11.2,
  ry: 11.2,
  transform: "translate(64 64) rotate(180)",
  width: 64
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M44,56H20A12,12,0,0,1,8,44V20A12,12,0,0,1,20,8H44A12,12,0,0,1,56,20V44A12,12,0,0,1,44,56ZM20,12.8A7.21,7.21,0,0,0,12.8,20V44A7.21,7.21,0,0,0,20,51.2H44A7.21,7.21,0,0,0,51.2,44V20A7.21,7.21,0,0,0,44,12.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M32,45.6A13.6,13.6,0,1,1,45.6,32,13.61,13.61,0,0,1,32,45.6Zm0-22.4A8.8,8.8,0,1,0,40.8,32,8.81,8.81,0,0,0,32,23.2Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 45.6,
  cy: 19.2,
  r: 2.4
}));

function SvgInstagramIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.4d76621211eb6baa00765705bf305b6a.svg";
export { ForwardRef as ReactComponent };